/**
 * Skyyrizon Product Bundle — toggle add-ons, live total, add selected to cart.
 * Totals are the honest sum of checked items (main always included). Any real
 * bundle discount is applied by Shopify at checkout, not faked here.
 */
(function () {
  'use strict';

  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function initBundle(root) {
    var main = root.querySelector('[data-sky-bundle-main]');
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-sky-bundle-addon]'));
    var totalEl = root.querySelector('[data-sky-bundle-total]');
    var addBtn = root.querySelector('[data-sky-bundle-add]');

    function recalc() {
      var total = main ? parseInt(main.getAttribute('data-price'), 10) : 0;
      addons.forEach(function (a) { if (a.checked) total += parseInt(a.getAttribute('data-price'), 10) || 0; });
      if (totalEl) totalEl.textContent = money(total);
    }

    addons.forEach(function (a) {
      a.addEventListener('change', function () {
        a.closest('.sky-bundle__item').classList.toggle('is-off', !a.checked);
        recalc();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        if (main) items.push({ id: main.getAttribute('data-variant-id'), quantity: 1 });
        addons.forEach(function (a) { if (a.checked) items.push({ id: a.getAttribute('data-variant-id'), quantity: 1 }); });
        if (!items.length) return;

        var orig = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js?sections=cart-icon-bubble,cart-live-region-text', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
          .then(function () {
            // fetch fresh sections for the cart bubble
            return fetch('/?sections=cart-icon-bubble,cart-live-region-text').then(function (r) { return r.json(); });
          })
          .then(function (sections) {
            addBtn.textContent = 'Added ✓';
            syncCart(sections);
            toast(root, 'Bundle added to cart');
            window.setTimeout(function () { addBtn.textContent = orig; addBtn.disabled = false; }, 1600);
          })
          .catch(function (err) {
            addBtn.textContent = (err && err.description) || 'Could not add';
            window.setTimeout(function () { addBtn.textContent = orig; addBtn.disabled = false; }, 1800);
          });
      });
    }

    recalc();
  }

  function syncCart(sections) {
    if (!sections) return;
    ['cart-icon-bubble', 'cart-live-region-text'].forEach(function (key) {
      if (!sections[key]) return;
      try {
        var doc = new DOMParser().parseFromString(sections[key], 'text/html');
        var next = doc.querySelector('#shopify-section-' + key);
        var cur = document.getElementById('shopify-section-' + key);
        if (next && cur) cur.replaceWith(next);
      } catch (e) {}
    });
    if (window.PUB_SUB_EVENTS && window.publish) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'skyyrizon-product-bundle' });
  }

  function toast(scope, msg) {
    var t = scope.querySelector('[data-sky-cc-toast]') || document.querySelector('[data-sky-cc-toast]');
    if (!t) return;
    var txt = t.querySelector('.sky-cc-toast__text'); if (txt) txt.textContent = msg;
    t.classList.add('is-visible');
    window.clearTimeout(t._timer);
    t._timer = window.setTimeout(function () { t.classList.remove('is-visible'); }, 1800);
  }

  function init() { document.querySelectorAll('[data-sky-bundle]').forEach(initBundle); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
